/* eslint-disable @typescript-eslint/no-floating-promises */

import { ErrorPage } from '@/pages/Common/Error/Error'
import { NotFound } from '@/pages/Common/NotFound/NotFound'
import { Home } from '@/pages/Public/Home/Home'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'

const LanguageWrapper = ({ children }: { children: any }): any => {
  const { i18n } = useTranslation()
  const location = useLocation()
  const language = location.pathname.split('/')[1]

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') ?? 'en_US'
    if (['en', 'en_US', 'es', 'es_ES'].includes(language)) {
      const newLanguage = language.startsWith('en') ? 'en_US' : 'es_ES'
      i18n.changeLanguage(newLanguage)
      localStorage.setItem('language', newLanguage)
    } else {
      i18n.changeLanguage(storedLanguage)
    }
  }, [language, i18n])

  return <>{children}</>
}

const AppRouter = (): JSX.Element => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <LanguageWrapper>
        <Routes>
          <Route path='/en' element={<Navigate to='/' />} />
          <Route path='/en_US' element={<Navigate to='/' />} />
          <Route path='/es' element={<Navigate to='/' />} />
          <Route path='/es_ES' element={<Navigate to='/' />} />
          <Route path='/' element={<Home />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/error/:errorType' element={<ErrorPage />} />
        </Routes>
      </LanguageWrapper>
    </BrowserRouter>
  )
}

export default AppRouter
